import React, { createContext, useContext, useState } from "react";

// Translations
export const translations = {
  en: {
    login: "Login",
    createAccount: "Create Account",
    forgotPassword: "Forgot Password?",
    phoneOrEmail: "Phone / Gmail",
    pin: "6-Digit PIN",
    name: "Full Name",
    email: "Email Address",
    sendOTP: "Send OTP",
    enterOTP: "Enter OTP",
    verifyOTP: "Verify OTP",
    country: "Country",
    referralCode: "Referral Code (Optional)",
    referralHint: "You'll get 1000 LTG bonus!",
    welcome: "Welcome",
    deposit: "Deposit",
    withdraw: "Withdraw",
    buy: "Buy",
    sell: "Sell",
    send: "Send",
    receive: "Receive",
    walletAddress: "Wallet Address",
    copyAddress: "Copy Address",
    bscOnly: "BSC Network Only!",
    txHash: "Transaction Hash",
    submit: "Submit",
    minWithdraw: "Minimum Withdrawal: 5 USDT",
    amount: "Amount",
    rate: "Rate: 1 USDT = 1000 LTG",
    youllGet: "You'll get",
    spin: "Spin",
    games: "Games",
    luckySpin: "Lucky Spin",
    totalWon: "Total Won",
    comeBackTomorrow: "Come back tomorrow!",
    refer: "Refer",
    referEarn: "Refer & Earn",
    yourCode: "Your Code",
    referrals: "Referrals",
    earned: "Earned",
    stake: "Stake",
    stakeLTG: "Stake LTG",
    dailyReward: "1% Daily Reward",
    staked: "Staked",
    unlock: "Unlock",
    reward: "Reward",
    history: "History",
    noTransactions: "No transactions yet",
    support: "Support",
    supportChat: "Support Chat",
    typeMessage: "Type your message...",
    sendMessage: "Send",
    recordAudio: "Hold to record",
    attachPhoto: "Attach Photo",
    noMessages: "No messages yet. Start a conversation!",
    chatDeleted: "Chat deleted",
    about: "About",
    aboutText: "Lite Gold (LTG) is a blockchain-based digital project focused on building a secure, transparent ecosystem for modern users worldwide.",
    companyAddress: "Company Address (USA)",
    version: "Version 1.2.0",
    admin: "Admin",
    users: "Users",
    transactions: "Transactions",
    settings: "Settings",
    block: "Block",
    unblock: "Unblock",
    approve: "Approve",
    reject: "Reject",
    changePin: "Change Admin PIN",
    currentPin: "Current PIN",
    newPin: "New PIN",
    confirmPin: "Confirm PIN",
    save: "Save",
    logout: "Logout",
    resetPassword: "Reset Password",
    enterNewPin: "Enter New 6-Digit PIN",
    passwordResetSuccess: "Password Reset Successfully!",
    recipient: "Recipient (Phone/Email/Wallet)",
    share: "Share",
    live: "LIVE",
    locked: "LOCKED",
    pending: "Pending",
    completed: "Completed",
    rejected: "Rejected",
    emailVerified: "Email Verified",
    verifyEmail: "Please verify your email first",
    min5UsdtWithdraw: "Minimum 5 USDT Withdrawal - Once you earn 5 USDT, you can withdraw!",
    referEarnDesc: "Share your code - When someone creates an account using your code, you'll get 1000 LTG!",
    referralEarnedStaked: "Referral Earned and Staked",
    allStakeEarningHome: "To see all Stake & Earning, go to Home page"
  },
  hi: {
    login: "लॉगिन",
    createAccount: "खाता बनाएं",
    forgotPassword: "पासवर्ड भूल गए?",
    phoneOrEmail: "फ़ोन / Gmail",
    pin: "6-अंकीय पिन",
    name: "पूरा नाम",
    email: "ईमेल पता",
    sendOTP: "OTP भेजें",
    enterOTP: "OTP दर्ज करें",
    verifyOTP: "OTP सत्यापित करें",
    country: "देश",
    referralCode: "रेफरल कोड (वैकल्पिक)",
    referralHint: "आपको 1000 LTG बोनस मिलेगा!",
    welcome: "स्वागत है",
    deposit: "जमा",
    withdraw: "निकासी",
    buy: "खरीदें",
    sell: "बेचें",
    send: "भेजें",
    receive: "प्राप्त करें",
    walletAddress: "वॉलेट पता",
    copyAddress: "पता कॉपी करें",
    bscOnly: "केवल BSC नेटवर्क!",
    txHash: "ट्रांजैक्शन हैश",
    submit: "सबमिट",
    minWithdraw: "न्यूनतम निकासी: 5 USDT",
    amount: "राशि",
    rate: "दर: 1 USDT = 1000 LTG",
    youllGet: "आपको मिलेगा",
    spin: "स्पिन",
    games: "गेम्स",
    luckySpin: "लकी स्पिन",
    totalWon: "कुल जीत",
    comeBackTomorrow: "कल वापस आएं!",
    refer: "रेफर",
    referEarn: "रेफर करें और कमाएं",
    yourCode: "आपका कोड",
    referrals: "रेफरल",
    earned: "कमाई",
    stake: "स्टेक",
    stakeLTG: "LTG स्टेक करें",
    dailyReward: "1% दैनिक रिवॉर्ड",
    staked: "स्टेक किया",
    unlock: "अनलॉक",
    reward: "रिवॉर्ड",
    history: "इतिहास",
    noTransactions: "अभी तक कोई लेनदेन नहीं",
    support: "सहायता",
    supportChat: "सहायता चैट",
    typeMessage: "अपना संदेश लिखें...",
    sendMessage: "भेजें",
    recordAudio: "रिकॉर्ड करने के लिए दबाएं",
    attachPhoto: "फोटो जोड़ें",
    noMessages: "अभी तक कोई संदेश नहीं। बातचीत शुरू करें!",
    chatDeleted: "चैट हटा दी गई",
    about: "के बारे में",
    aboutText: "Lite Gold (LTG) एक ब्लॉकचेन-आधारित डिजिटल प्रोजेक्ट है जो दुनिया भर के आधुनिक उपयोगकर्ताओं के लिए एक सुरक्षित, पारदर्शी इकोसिस्टम बनाने पर केंद्रित है।",
    companyAddress: "कंपनी का पता (USA)",
    version: "संस्करण 1.2.0",
    admin: "एडमिन",
    users: "उपयोगकर्ता",
    transactions: "लेनदेन",
    settings: "सेटिंग्स",
    block: "ब्लॉक",
    unblock: "अनब्लॉक",
    approve: "स्वीकृत",
    reject: "अस्वीकृत",
    changePin: "एडमिन पिन बदलें",
    currentPin: "वर्तमान पिन",
    newPin: "नया पिन",
    confirmPin: "पिन की पुष्टि करें",
    save: "सहेजें",
    logout: "लॉगआउट",
    resetPassword: "पासवर्ड रीसेट",
    enterNewPin: "नया 6-अंकीय पिन दर्ज करें",
    passwordResetSuccess: "पासवर्ड सफलतापूर्वक रीसेट हो गया!",
    recipient: "प्राप्तकर्ता (फोन/ईमेल/वॉलेट)",
    share: "शेयर",
    live: "लाइव",
    locked: "लॉक",
    pending: "लंबित",
    completed: "पूर्ण",
    rejected: "अस्वीकृत",
    emailVerified: "ईमेल सत्यापित",
    verifyEmail: "कृपया पहले अपना ईमेल सत्यापित करें",
    min5UsdtWithdraw: "Minimum 5 USDT Withdrawal - जैसे ही 5 USDT कमाई होगी आप Withdraw कर सकते हैं!",
    referEarnDesc: "अपना code शेयर करें - जब कोई आपके code से ID बनाएगा, आपको 1000 LTG मिलेगा!",
    referralEarnedStaked: "Referral से कमाई और Stake",
    allStakeEarningHome: "सभी Stake और Earning देखने के लिए Home पर जाएं"
  },
  ur: {
    login: "لاگ ان",
    createAccount: "اکاؤنٹ بنائیں",
    forgotPassword: "پاس ورڈ بھول گئے؟",
    phoneOrEmail: "فون / Gmail",
    pin: "6-ہندسی پن",
    name: "پورا نام",
    email: "ای میل پتہ",
    sendOTP: "OTP بھیجیں",
    enterOTP: "OTP درج کریں",
    verifyOTP: "OTP تصدیق کریں",
    country: "ملک",
    referralCode: "ریفرل کوڈ (اختیاری)",
    referralHint: "آپ کو 1000 LTG بونس ملے گا!",
    welcome: "خوش آمدید",
    deposit: "جمع",
    withdraw: "واپسی",
    buy: "خریدیں",
    sell: "بیچیں",
    send: "بھیجیں",
    receive: "وصول کریں",
    walletAddress: "والیٹ پتہ",
    copyAddress: "پتہ کاپی کریں",
    bscOnly: "صرف BSC نیٹ ورک!",
    txHash: "ٹرانزیکشن ہیش",
    submit: "جمع کرائیں",
    minWithdraw: "کم از کم واپسی: 5 USDT",
    amount: "رقم",
    rate: "شرح: 1 USDT = 1000 LTG",
    youllGet: "آپ کو ملے گا",
    spin: "سپن",
    games: "گیمز",
    luckySpin: "لکی سپن",
    totalWon: "کل جیت",
    comeBackTomorrow: "کل واپس آئیں!",
    refer: "ریفر",
    referEarn: "ریفر کریں اور کمائیں",
    yourCode: "آپ کا کوڈ",
    referrals: "ریفرلز",
    earned: "کمائی",
    stake: "اسٹیک",
    stakeLTG: "LTG اسٹیک کریں",
    dailyReward: "1% روزانہ انعام",
    staked: "اسٹیک شدہ",
    unlock: "ان لاک",
    reward: "انعام",
    history: "تاریخ",
    noTransactions: "ابھی تک کوئی لین دین نہیں",
    support: "مدد",
    supportChat: "مدد چیٹ",
    typeMessage: "اپنا پیغام لکھیں...",
    sendMessage: "بھیجیں",
    recordAudio: "ریکارڈ کرنے کے لیے دبائیں",
    attachPhoto: "تصویر منسلک کریں",
    noMessages: "ابھی تک کوئی پیغام نہیں۔ بات چیت شروع کریں!",
    chatDeleted: "چیٹ حذف کر دی گئی",
    about: "کے بارے میں",
    aboutText: "Lite Gold (LTG) ایک بلاکچین پر مبنی ڈیجیٹل پروجیکٹ ہے جو دنیا بھر کے جدید صارفین کے لیے ایک محفوظ، شفاف ایکو سسٹم بنانے پر مرکوز ہے۔",
    companyAddress: "کمپنی کا پتہ (USA)",
    version: "ورژن 1.2.0",
    admin: "ایڈمن",
    users: "صارفین",
    transactions: "لین دین",
    settings: "ترتیبات",
    block: "بلاک",
    unblock: "ان بلاک",
    approve: "منظور",
    reject: "مسترد",
    changePin: "ایڈمن پن تبدیل کریں",
    currentPin: "موجودہ پن",
    newPin: "نیا پن",
    confirmPin: "پن کی تصدیق",
    save: "محفوظ کریں",
    logout: "لاگ آؤٹ",
    resetPassword: "پاس ورڈ ری سیٹ",
    enterNewPin: "نیا 6-ہندسی پن درج کریں",
    passwordResetSuccess: "پاس ورڈ کامیابی سے ری سیٹ ہو گیا!",
    recipient: "وصول کنندہ (فون/ای میل/والیٹ)",
    share: "شیئر کریں",
    live: "لائیو",
    locked: "لاک",
    pending: "زیر التواء",
    completed: "مکمل",
    rejected: "مسترد",
    emailVerified: "ای میل تصدیق شدہ",
    verifyEmail: "براہ کرم پہلے اپنا ای میل تصدیق کریں",
    min5UsdtWithdraw: "کم از کم 5 USDT واپسی - جیسے ہی 5 USDT کمائی ہوگی آپ واپس لے سکتے ہیں!",
    referEarnDesc: "اپنا کوڈ شیئر کریں - جب کوئی آپ کے کوڈ سے ID بنائے گا، آپ کو 1000 LTG ملے گا!",
    referralEarnedStaked: "ریفرل سے کمائی اور اسٹیک",
    allStakeEarningHome: "تمام Stake اور Earning دیکھنے کے لیے Home پر جائیں"
  }
};

// Language Context
const LanguageContext = createContext(null);

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("ltg_lang") || "en");

  const t = (key) => translations[lang]?.[key] || translations["en"][key] || key;
  const changeLang = (l) => { setLang(l); localStorage.setItem("ltg_lang", l); };
  const langs = Object.keys(translations);

  return (
    <LanguageContext.Provider value={{ lang, t, changeLang, langs }}>
      {children}
    </LanguageContext.Provider>
  );
};
